import { UsageDto } from 'src/proxy/model/usageDto';
import { Usage } from '@app/models/Usage';

export function mapUsageDtoToUsage(dto: UsageDto): Usage {
  return <Usage>{
    remaining: dto?.Remaining || 0,
    total: dto?.Total || 0,
  };
}
